// extracted by mini-css-extract-plugin
export default {"wrap":"NF-z","subtitle":"OF-z","contentWrap":"PF-z","imgWrap":"QF-z","heading":"RF-z","copy":"SF-z"};